import { useMutation } from "@tanstack/react-query";
import { get } from "lodash";
import { api } from "../../services";

interface IPostOptions {
  url: string;
  onSuccess?: (data: { [key: string]: any }) => any;
  onError?: (error: { [key: string]: any }) => any;
}

const removeData = ({
  url,
  onSuccess = () => { },
  onError = () => { },
}: IPostOptions) => {
  return  api
    .delete(url)
    .then((data) => {
      onSuccess(get(data, "data"));
    })
    .catch((error) => {
      onError(error);
    });
};

const useDelete = () => {
  return useMutation({ mutationFn: removeData });
};

export default useDelete;
